import { UIRouterModule } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { CdnImgModule } from "@webapp/shared/directives/cdn-img/cdn-img.module";
import { RichTextEditorModule } from "@webapp/shared/rich-text-editor/rich-text-editor.module";
import { UiAvatarModule } from "@webapp/ui/avatar/avatar.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { BadgeAssignmentComponent } from "./components/badge-assignment/badge-assignment.component";
import { BadgeAwardListComponent } from "./components/badge-award-list/badge-award-list.component";
import { ConfirmBadgeDeleteComponent } from "./components/confirm-badge-delete/confirm-badge-delete.component";
import { FromBadgeDirective } from "./directives/from-badge.directive";
import { ConfirmBadgeActionService } from "./services/confirm-badge-action.service";

@NgModule({
  declarations: [BadgeAssignmentComponent, BadgeAwardListComponent, ConfirmBadgeDeleteComponent, FromBadgeDirective],
  exports: [BadgeAssignmentComponent, BadgeAwardListComponent, FromBadgeDirective],
  imports: [CommonModule, UIRouterModule, AssigneesModule, UiIconModule, RichTextEditorModule, UiAvatarModule, CdnImgModule, LocalizationModule],
  providers: [ConfirmBadgeActionService],
})
export class BadgesModule {}
